import React, {useEffect, useState} from 'react';
import s from './CreateProductCatalog.module.css';
import style from '../PopupsCommonStyle.module.css';
import {Field, FormikErrors, useFormikContext} from 'formik';

import {UserClient} from '../../../../types/TypesUser';
import FindDistributorsComponent from '../../../../Components/FindDistributorsComponent/FindDistributorsComponent';
import {useTranslation} from 'react-i18next';

type Props = {
	index: number;
};

const DeferredOrdersForm = ({index}: Props) => {
	const {t} = useTranslation();
	const [client, setClient] = useState<UserClient | null>(null);
	const {setFieldValue, values, errors} = useFormikContext<any>();

	useEffect(() => {
		setFieldValue(`orders[${index}].user_id`, client?.client_id);
	}, [client]);

	const orderErrors = errors.orders as
		| FormikErrors<{points: string; user_id: string}>[]
		| undefined;

	return (
		<div className={s.editContainer}>
			<FindDistributorsComponent client={client} setClient={setClient} />
			<div className={style.fieldElement}>
				<div className={style.fieldElement_Name}>{t('Бали для оформлення')}</div>
				<div className={`${style.fieldElement_Input} ${s.input}`}>
					<Field
						className={`${style.input} `}
						placeholder={t('Введіть кількість балів')}
						onChange={({currentTarget}: any) => {
							const isValid = /^\d*\.?\d{0,1}$/.test(currentTarget.value);
							if (isValid || currentTarget.value === '') {
								setFieldValue(`orders[${index}].points`, currentTarget.value);
							}
						}}
						name={`orders[${index}].points`}
						value={values.orders[index]?.points}
					/>
					{orderErrors?.[index]?.points && (
						<div className={style.errorMessage}>{orderErrors[index].points}</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default DeferredOrdersForm;
